<template>
  <!--
      作者：luoyiming
      时间：2019-10-25
      描述：应用-公众号设置
  -->
  <div class="product-add">
    <!--form表单-->
    <el-form size="small" ref="form" :model="form" label-width="250px">
      <!--公众号设置-->
      <div class="common-form">公众号设置</div>

      <el-form-item label="AppID 公众号ID">
        <el-input v-model="form.mpappId" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="AppSecret 公众号密钥">
        <el-input v-model="form.mpapp_secret" type="password" class="max-w460"></el-input>
      </el-form-item>
      <div class="menu-oa">
        <el-card class="!border-none" shadow="never">
            <el-alert
                type="warning"
                title="配置微信公众号菜单，点击确认，保存菜单并发布至微信公众号"
                :closable="false"
                show-icon
            />
        </el-card>

        <el-card class="!border-none mt-4" shadow="never">
            <div class="lg:flex flex-1">
                <!-- Phone -->
                <OaPhone :menuList.sync ="menuList" :menuIndex.sync="menuIndex" ></OaPhone>

                <!-- Attr -->
                <div class="mt-4 lg:mt-0 max-w-[400px]">
                    <OaAttr :menuList.sync ="menuList" :menuIndex.sync="menuIndex" @update="update"></OaAttr>
                </div>
            </div>
        </el-card>

       
    </div>
      <!--提交-->
      <div class="common-button-wrapper">
          <el-button type="primary" @click="onSubmit">提交</el-button>
      </div>
    </el-form>


  </div>

</template>

<script>
  import AppSettingApi from '@/api/appsetting.js';
  import OaPhone from './menu_com/oa-phone'
  import OaAttr from './menu_com/oa-attr'

  export default {
    components: {
        OaPhone,
        OaAttr
      },
    data() {
      
      return {
        /*切换菜单*/
        // activeIndex: '1',
        /*form表单数据*/
        form: {
        },
        menuList:[],
        menuIndex:0


      };
    },
    created() {
      this.getData()
    },

    methods: {
      update(e){
        this.menuList=e
        console.log(e,'子粗安抚')
      },
      /*获取数据*/
      getData() {
        let self = this;
        AppSettingApi.appmpDetail({}, true)
          .then(data => {
            if(data.data.data != null){
              self.form = data.data.data;
              self.menuList=data.data.data.menu
              // console.log(self.form.menu)
            }
          })
          .catch(error => {});

      },
      
      /*提交表单*/
      onSubmit() {
        let self = this;
        let a=JSON.stringify( self.menuList);
        delete(this.form.menu)
        let params = this.form;

        params.menu = a;
        AppSettingApi.editAppMp(params, true)
          .then(data => {
            self.$message({
              message: '恭喜你，设置成功',
              type: 'success'
            });
            self.$router.push('/appsetting/appmp/index');
          })
          .catch(error => {

          });
      },
    }

  };
</script>

<style>
  .tips {
    color: #ccc;
  }
  .lg\:flex {
        display: flex;
    }
    .flex-1{
      flex:1 1 0%;
    }
    .mr-\[35px\] {
    margin-right: 35px;
}
</style>



// WEBPACK FOOTER //
// src/views/appsetting/appmp/index.vue